export const FEATURE_FLAGS = {
  EnableDemoIngestions: 'EnableDemoIngestions',
  EnableIngestionScheduling: 'EnableIngestionScheduling',
  EnableBookings: 'EnableBookings',
  EnableSalesDemo: 'EnableSalesDemo',
  EnableContentStore: 'EnableContentStore',
  EnableEnablement: 'EnableEnablement',
  EnablePartnerPortal: 'EnablePartnerPortal',
  EnableAnalytics: 'EnableAnalytics',
  EnableAdmin: 'EnableAdmin',
  EnableAccountManagement: 'EnableAccountManagement',
  EnableTenantManagement: 'EnableTenantManagement',
  EnableAlertManagement: 'EnableAlertManagement',
  EnableAccountRequestNotifications: 'EnableAccountRequestNotifications',
  EnableForgetPassword: 'EnableForgetPassword',
  EnableAccountRequest: 'EnableAccountRequest',
  EnableWhatsNew: 'EnableWhatsNew',
  EnableFAQ: 'EnableFAQ',
  EnableEmailNotifications: 'EnableEmailNotifications',
  EnableAgent: 'EnableAgent',
  EnableSearch: 'EnableSearch',
  EnableEmailMigration: 'EnableEmailMigration',
  EnableSupport: 'EnableSupport',
};
